import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { EpErrorHandlerService } from "../shared/services/epErrorHandlerService/epErrorHandler.service";
import { ReplaySubject } from "rxjs";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"],
  standalone: false,
})
export class MainComponent implements OnInit {
  errors$: ReplaySubject<string[]>;

  constructor(
    private router: Router,
    private location: Location,
    private errorService: EpErrorHandlerService,
  ) {}

  ngOnInit() {
    // Suppress ODS Web Components DOM validation warnings about duplicate IDs
    const originalWarn = console.warn;
    console.warn = function (...args) {
      if (
        args[0]?.includes?.("[DOM] Found") ||
        args[0]?.includes?.("non-unique id")
      ) {
        return; // Suppress these specific warnings
      }
      originalWarn.apply(console, args);
    };
    this.errors$ = this.errorService.get();
    // business requirement:
    const path = this.location.path();
    const isPdfRoute =
      !!path && path.indexOf("/main/quoting/generate-proposal-pdf/") > -1;
    const isRootMainRoute =
      !path || path === "/main" || path === "/main/" || path === "/main#";

    if (!isPdfRoute && isRootMainRoute) {
      this.router.navigate(["/main/new-sales-dashboard"]);
    }
  }
}
